import { IconFont } from '@byecode/ui/components/IconFont'
import { Menu } from '@byecode/ui/components/Menu'
import { useCurrentEditor } from '@tiptap/react'
import type { FC } from 'react'
import React from 'react'

import { useLanguageContext } from '../../../contexts'
import type { I18TranslationKey } from '../../../types'
import { isMobileDevice } from '../../../utils/getApplicationPreviewType'
import { DropdownActionButton } from './styles'

const OPTIONS = [
    {
        label: 'alignCenter',
        icon: <IconFont type="TextAlignCenter" />,
        value: 'center'
    },
    {
        label: 'alignLeft',
        icon: <IconFont type="TextAlignLeft" />,
        value: 'left'
    },
    {
        label: 'alignRight',
        icon: <IconFont type="TextAlignRight" />,
        value: 'right'
    }
]

export const AlignMenu: FC = () => {
    const { editor } = useCurrentEditor()
    const { convertTextByLanguage } = useLanguageContext()

    const current = editor?.isActive({ textAlign: 'center' })
        ? 'TextAlignCenter'
        : editor?.isActive({ textAlign: 'right' })
        ? 'TextAlignRight'
        : 'TextAlignLeft'

    return (
        <Menu withinPortal zIndex={300} width={150} trigger={isMobileDevice() ? 'click' : 'hover'} position="bottom">
            <Menu.Target>
                <DropdownActionButton>
                    <IconFont size={16} type={current} />
                    <IconFont size={10} type="ArrowDownSmallGray" color="var(--color-gray-500)" />
                </DropdownActionButton>
            </Menu.Target>
            <Menu.Dropdown>
                {OPTIONS.map(item => (
                    <Menu.Item
                        key={item.value}
                        icon={item.icon}
                        style={editor?.isActive({ textAlign: item.value }) ? { backgroundColor: 'var(--color-gray-100)' } : {}}
                        onClick={() =>
                            editor?.isActive({ textAlign: item.value })
                                ? editor.chain().focus().unsetTextAlign().run()
                                : editor?.chain().focus().setTextAlign(item.value).run()
                        }
                    >
                        {convertTextByLanguage(item.label as I18TranslationKey)}
                    </Menu.Item>
                ))}
            </Menu.Dropdown>
        </Menu>
    )
}
